/** Wire enums — mirror ART-19555's `ResidentFeedbackInputBean`. Values must match the schema. */
export enum ResidentFeedbackResult {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  DISMISSED = 'DISMISSED',
}

export enum ResidentFeedbackCategory {
  BUG = 'BUG',
  IDEA = 'IDEA',
  UX = 'UX',
  OTHER = 'OTHER',
}

export enum ResidentFeedbackPlatform {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  // Web splits by form factor. NativeScript only ever sends IOS or ANDROID;
  // these two exist so ART-19558 has the values it needs.
  WEB_MOBILE = 'WEB_MOBILE',
  WEB_OTHER = 'WEB_OTHER',
}

/** UI-only. The sheet is one component with three steps; see the ART-19551 spec. */
export enum FeedbackPromptStep {
  PROMPT = 'PROMPT',
  NEGATIVE_FORM = 'NEGATIVE_FORM',
  THANK_YOU = 'THANK_YOU',
}
